import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  Button,
  Typography,
  Collapse,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CreateButtonWithModal from '../components/common/CreateButtonWithModal';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import EditModal from '../components/common/EditModal';
import ViewModal from '../components/common/ViewModal';
import Tooltip from '../components/common/Tooltip';
import CustomSwitch from '../components/common/CustomSwitch';

interface Column {
  id: keyof Data | 'action';
  label: string;
  minWidth?: number;
  align?: 'right' | 'center' | 'left';
}

const columns: readonly Column[] = [
  { id: 'role name', label: 'Role Name' },
  { id: 'action', label: 'Action', align: 'center' },
];

interface Data {
  'role name': string;
}

function createData(
  rolename: string
): Data {
  return { 
    'role name': rolename
   };
}

const initialRows: Data[] = [
  createData('Raj'),
  createData('John'),
  createData('Emma'),
  createData('Satoshi'),
];
interface ViewModalProps {
  open: boolean;
  onClose: () => void;
  initialData: Data;
  title: string;
}


const Roles = () => {
  const [openRevenue, setOpenRevenue] = React.useState(true);
  const [openSupplier, setOpenSupplier] = React.useState(true);
  const [openData, setOpenData] = React.useState(true);
  const [openUser, setOpenUser] = React.useState(true);
  const [openSystem, setOpenSystem] = React.useState(true);
  const [rows, setRows] = useState<Data[]>(initialRows);
  const [editOpen, setEditOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterBy, setFilterBy] = useState('');

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearch = () => {
    console.log(`Searching for "${searchTerm}" by ${filterBy}`);
  };

  const handleEditSave = (updatedData: Data) => {
    if (selectedRowIndex === null) return;
    const updatedRows = [...rows];
    updatedRows[selectedRowIndex] = updatedData;
    setRows(updatedRows);
    setEditOpen(false);
  };


  const handleDeleteRow = (rolename: string) => {
    const updatedRows = rows.filter((row) => row['role name'] !== rolename);
    setRows(updatedRows);
    console.log(`Deleted row with role name: ${rolename}`);
  };
  
  const renderActions = (row: Data, index: number) => (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={() => {
          setSelectedRowIndex(index);
          setEditOpen(true);
        }}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        color="primary"
        size="small"
        onClick={() => {
          setSelectedRowIndex(index);
          setViewOpen(true);
        }}
      >
        <RemoveRedEyeIcon />
      </IconButton>
      
    </>
  );
  

    const [labelName, setLabelName] = React.useState<string[]>([]);
        
          const labelChange = (event: SelectChangeEvent<typeof labelName>) => {
            const {
              target: { value },
            } = event;
            setLabelName(
              // On autofill we get a stringified value.
              typeof value === 'string' ? value.split(',') : value,
            );
          };

  return (
    <>
       <Box className="headingBtnWrap">
       <Typography variant="h1">Roles</Typography>
              <CreateButtonWithModal buttonLabel="Create Role" modalTitle="Create Role">
                 <Box className="modalFormWrap">
              <Box component="form" className="modalForm">
                  <div className="form-control inputFieldWrap">
                      <label>Role name</label>
                      <input type="text" className='inputField' />
                  </div>
                  <div className="form-control inputFieldWrap">
                      <label>Description</label>
                      <input type="text" className='inputField' />
                  </div>
              </Box>
              <TableContainer className='rolesPage'>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Create</TableCell>
            <TableCell>Update</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <React.Fragment>
            {/* Main Row */}
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className='mainRow'>
              <TableCell className='headingCell'>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpenRevenue(!openRevenue)}
                  sx={{ verticalAlign: 'middle' }}
                  className='expandButton'
                >
                  Revenue Management
                  {openRevenue ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
                
              </TableCell>
              <TableCell><CustomSwitch /></TableCell>
              <TableCell><CustomSwitch /></TableCell>
            </TableRow>

            {/* Collapsible Content */}
            <TableRow>
              <TableCell style={{ padding: 0, paddingTop: 0 }} colSpan={3} className='innerTableCell'>
                <Collapse in={openRevenue} timeout="auto" unmountOnExit>
                  <Box>
                    <Table size="small" aria-label="nested table">
                      <TableBody>
                        <TableRow>
                          <TableCell className='headingCell'>Flight</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Stay</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
          <React.Fragment>
            {/* Main Row */}
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className='mainRow'>
              <TableCell className='headingCell'>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpenSupplier(!openSupplier)}
                  sx={{ verticalAlign: 'middle' }}
                  className='expandButton'
                >
                  Supplier Management
                  {openSupplier ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
                
              </TableCell>
              <TableCell><CustomSwitch /></TableCell>
              <TableCell><CustomSwitch /></TableCell>
            </TableRow>

            {/* Collapsible Content */}
            <TableRow>
              <TableCell style={{ padding: 0, paddingTop: 0 }} colSpan={3} className='innerTableCell'>
                <Collapse in={openSupplier} timeout="auto" unmountOnExit>
                  <Box>
                    <Table size="small" aria-label="nested table">
                      <TableBody>
                        <TableRow>
                          <TableCell className='headingCell'>Flight</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Stay</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
          <React.Fragment>
            {/* Main Row */}
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className='mainRow'>
              <TableCell className='headingCell'>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpenData(!openData)}
                  sx={{ verticalAlign: 'middle' }}
                  className='expandButton'
                >
                  Data Management
                  {openData ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
                
              </TableCell>
              <TableCell><CustomSwitch /></TableCell>
              <TableCell><CustomSwitch /></TableCell>
            </TableRow>

            {/* Collapsible Content */}
            <TableRow>
              <TableCell style={{ padding: 0, paddingTop: 0 }} colSpan={3} className='innerTableCell'>
                <Collapse in={openData} timeout="auto" unmountOnExit>
                  <Box>
                    <Table size="small" aria-label="nested table">
                      <TableBody>
                        <TableRow>
                          <TableCell className='headingCell'>Flight</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Stay</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
          <React.Fragment>
            {/* Main Row */}
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className='mainRow'>
              <TableCell className='headingCell'>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpenUser(!openUser)}
                  sx={{ verticalAlign: 'middle' }}
                  className='expandButton'
                >
                  User Management
                  {openUser ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
                
              </TableCell>
              <TableCell><CustomSwitch /></TableCell>
              <TableCell><CustomSwitch /></TableCell>
            </TableRow>

            {/* Collapsible Content */}
            <TableRow>
              <TableCell style={{ padding: 0, paddingTop: 0 }} colSpan={3} className='innerTableCell'>
                <Collapse in={openUser} timeout="auto" unmountOnExit>
                  <Box>
                    <Table size="small" aria-label="nested table">
                      <TableBody>
                        <TableRow>
                          <TableCell className='headingCell'>Create Users</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Roles</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>User Access</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Role Access</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
          <React.Fragment>
            {/* Main Row */}
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className='mainRow'>
              <TableCell className='headingCell'>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => setOpenSystem(!openSystem)}
                  sx={{ verticalAlign: 'middle' }}
                  className='expandButton'
                >
                  System
                  {openSystem ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
                
              </TableCell>
              <TableCell><CustomSwitch /></TableCell>
              <TableCell><CustomSwitch /></TableCell>
            </TableRow>

            {/* Collapsible Content */}
            <TableRow>
              <TableCell style={{ padding: 0, paddingTop: 0 }} colSpan={3} className='innerTableCell'>
                <Collapse in={openSystem} timeout="auto" unmountOnExit>
                  <Box>
                    <Table size="small" aria-label="nested table">
                      <TableBody>
                        <TableRow>
                          <TableCell className='headingCell'>General</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Mandatory Information</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Payments</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className='headingCell'>Notifications</TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                          <TableCell><CustomSwitch /></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </React.Fragment>
        </TableBody>
      </Table>
    </TableContainer>
              <Box display="flex" justifyContent="flex-end">
                  <Button variant="contained" className='formBtn'>Save</Button>
                  </Box>
                  </Box>
            </CreateButtonWithModal>
            </Box>
            <Box className="searchInputWrap">
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={2}
                    p={2}
                    sx={{ width: '100%'}}
                    className="searchInputFilterBox searchInputBox"
                  >
                    <div className="form-control inputFieldWrap">
                      <label>Role</label>
                      <input type="text" className='inputField' placeholder='Search Role' />
                  </div>
                    <Button
                            variant="contained"
                            className="searchBtn"
                            color="primary"
                            type="submit"
                            sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                          >
                            Search
                          </Button>
                  </Box>
                </Box>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    style={{ minWidth: column.minWidth }}
                    sx={{ minWidth: 175 }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell sx={{ minWidth: 175 }} align="center">Audit Trail</TableCell>
                <TableCell sx={{ width: '100%', border: 'none' }} />
              </TableRow>
            </TableHead>
            <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                  <TableRow hover key={rowIndex}>
                                      {columns.map((column) => {
                                        const value = row[column.id as keyof Data];
                                        if (column.id === 'action') {
                                          return (
                                            <TableCell key={column.id} align="center" sx={{ minWidth: 175 }}>
                                              {renderActions(row, rowIndex)}
                                            </TableCell>
                                          );
                                        }
                                        
                                        
                                        return <TableCell key={column.id}>{value}</TableCell>;
                                      })}
                                      <TableCell align="center" sx={{ minWidth: 175 }}>
                                                          <Tooltip />
                                                        </TableCell>
                                                        <TableCell sx={{ width: '100%', border: 'none' }} />
                                    </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
      </Paper>

      {/* Edit Modal */}
              {selectedRowIndex !== null && (
                <EditModal
                  open={editOpen}
                  onClose={() => setEditOpen(false)}
                  initialData={rows[selectedRowIndex]}
                  onSave={handleEditSave}
                  excludeFields={['action', 'status']}
                  readOnlyFields={['createdBy']}
                  title="Edit Role"
                />
              )}

            {selectedRowIndex !== null && (
  <ViewModal
    open={viewOpen}
    onClose={() => setViewOpen(false)}
    initialData={rows[selectedRowIndex]}
    title="View Role"
  />
)}
    </>
  );
};

export default Roles;


